import React, {useEffect, useMemo} from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'

import useUser from '../hooks/useUser'
import {UserContext} from '../hooks/useUserContext'
import {getUserRoles} from './userUtils'
import {
  identifyUser,
  identifyUserProperties,
} from 'modules/common/utils/analytics'

const UserProvider = ({children}) => {
  const {error, loading, authUser, dbUser} = useUser()

  // set unique user id for analytics
  useEffect(() => {
    if (authUser) {
      const userId = get(authUser, 'uid')
      identifyUser(userId)
    }
  }, [authUser])

  // set user roles for analytics
  useEffect(() => {
    if (dbUser) {
      const userId = get(dbUser, 'uid')
      const roles = getUserRoles(dbUser)
      identifyUserProperties(userId, {roles})
    }
  }, [dbUser])

  const contextValue = useMemo(
    () => ({error, auth: authUser, value: dbUser, loading}),
    [error, loading, authUser, dbUser]
  )

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  )
}

UserProvider.propTypes = {
  children: PropTypes.any,
}

export default UserProvider
